import type { ApMismatchAlertSetting } from 'ap-openapi';

/**
 * target_key for the total amount field is fixed.
 * It is not backed by a report_form_input, so it is matched by this constant instead of a report_id.
 */
export const TOTAL_AMOUNT_TARGET_KEY = 'total_amount';

export const toEnabledTargetKeys = (
  settings: ApMismatchAlertSetting[],
  reportTypeId: string
): Set<string> => {
  const setting = settings.find(
    (setting) => setting.ap_report_type_id === reportTypeId
  );
  if (!setting?.is_enabled) return new Set();

  return new Set(setting.fields.map((field) => field.target_key));
};
